module.exports = "<div *ngIf=\"hasSysOpsPermission\">\n    <h2>Upload pharmacies PDF</h2>\n    <label for=\"pharmacies\">Import (pdf)</label>\n    <input id=\"pharmacies\" name=\"pharmacies\" type=\"file\" class=\"form-control\" (change)=\"onFileChange($event)\"\n        multiple=\"false\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pharmacies/pharmacies.component.html
// module id = 1123
// module chunks = 1